import React from 'react';

import './style.sass';

import ScrollAnimation from '../../../../../../../../core/ScrollAnimation';

const SeoErrorsSearch = () => {
    return (
        <div className="errors-search">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <div className="errors-search__content">
                    <div className="errors-search__subtitle errors-search__subtitle_top">
                        Все это позволяет повысить качество сайта по метрикам Proxima и поднять его
                        в поиске. Например:
                    </div>

                    <div className="errors-search__subtitle">
                        <span>1.</span>Увеличить количество региональных запросов в топе
                    </div>

                    <div className="errors-search__blocks">
                        <div className="errors-search__blocks_1">
                            <img
                                alt=""
                                src="/images/pic/seo-fintech/errors-serch-1.png"
                                loading="lazy"
                            />
                            <span className="errors-search__first">
                                с 6% до 38% от общего числа в ПС Яндекс
                            </span>
                        </div>
                        <div className="errors-search__blocks_1">
                            <img
                                alt=""
                                src="/images/pic/seo-fintech/errors-serch-2.png"
                                loading="lazy"
                            />
                            <span>с 9% до 32% в ПС Google</span>
                        </div>
                    </div>

                    <div className="errors-search__subtitle">
                        <span>2.</span>Увеличить поисковой трафик отдельных регионов в среднем на
                        10%
                    </div>

                    <div className="errors-search__block">
                        <img
                            alt=""
                            src="/images/pic/seo-fintech/errors-serch-3.png"
                            loading="lazy"
                        />
                    </div>

                    <div className="errors-search__subtitle">
                        <span>3.</span>Улучшить внутренние поведенческие для пользователей: глубину
                        просмотра на 10%, среднее время на сайте на 15%
                    </div>

                    <div className="errors-search__blocks">
                        <div className="errors-search__blocks_1 errors-search__blocks_top">
                            <img
                                alt=""
                                src="/images/pic/seo-fintech/errors-serch-4.png"
                                loading="lazy"
                            />
                        </div>

                        <div className="errors-search__blocks_1">
                            <img
                                alt=""
                                src="/images/pic/seo-fintech/errors-serch-5.png"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <div className="errors-search__subtitle">
                        <span>4.</span>Увеличить для приоритетных направлений количество ключевых
                        запросов в топе
                    </div>

                    <div className="errors-search__blocks">
                        <div className="errors-search__blocks_1">
                            <img
                                alt=""
                                src="/images/pic/seo-fintech/errors-serch-6.png"
                                loading="lazy"
                            />
                            <span className="errors-search__first">
                                с 5% до 25% от общего числа в ПС Яндекс
                            </span>
                        </div>

                        <div className="errors-search__blocks_1">
                            <img
                                alt=""
                                src="/images/pic/seo-fintech/errors-serch-7.png"
                                loading="lazy"
                            />
                            <span>с 24% до 49% в ПС Google</span>
                        </div>
                    </div>

                    <div className="errors-search__subtitle">
                        <span>5.</span>Поднять для приоритетных направлений небрендовый поисковой
                        трафик более чем в 2 раза.
                    </div>

                    <div className="errors-search__block">
                        <img
                            alt=""
                            src="/images/pic/seo-fintech/errors-serch-8.png"
                            loading="lazy"
                        />
                    </div>

                    <div className="errors-search__subtitle">
                        Итак, на основании своего опыта мы можем дать три универсальных совета для
                        SEO банков:
                    </div>

                    <div className="errors-search__advices">
                        <div className="errors-search__advice">
                            <div className="errors-search__advice_inner">
                                <span>1.</span>
                                Внедрение технических решений для регионального продвижения
                            </div>
                        </div>

                        <div className="errors-search__advice">
                            <div className="errors-search__advice_inner">
                                <span>2.</span>
                                Расширение структуры сайта новыми посадочными страницами
                            </div>
                        </div>

                        <div className="errors-search__advice">
                            <div className="errors-search__advice_inner">
                                <span>3.</span>
                                Проработка метрик качества под Proxima
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
        </div>
    );
};

export default SeoErrorsSearch;
